/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IAccountAddressTileViewProps } from './account-address-tile';

const AccountAddressTileView: React.FC<IAccountAddressTileViewProps> = props => {
    const { AccountAddressTile, heading, description, links } = props;

    return (
        <Module {...AccountAddressTile}>
            {heading}
            {description}
            {links}
        </Module>
    );
};

export default AccountAddressTileView;
